import { render, staticRenderFns } from "./tech.vue?vue&type=template&id=6b5954ff&scoped=true&"
import script from "./tech.vue?vue&type=script&lang=ts&"
export * from "./tech.vue?vue&type=script&lang=ts&"
import style0 from "./tech.vue?vue&type=style&index=0&id=6b5954ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5954ff",
  null
  
)

export default component.exports